export const AssessmentTypeEnum = {
    Choice: 1,
    MultyChoice: 2,
    DradAndDrop: 3,
    ClosedText: 4,
    OpenText: 5,
    YesNo: 6,
    Emoji: 7,
    Numbers: 8,

}
export const AssessmentTypeTextEnum = {
    Choice: "Choice",
    MultyChoice: "MultyChoice",
    DradAndDrop: "DradAndDrop",
    ClosedText: "ClosedText",
    OpenText: "OpenText",
    YesNo: "YesNo",
    Emoji: "Emoji",
    Numbers: "Numbers",
}

export const AssessmentTypeConvertTextEnum = {
    1: "Choice",
    2: "MultyChoice",
    3: "DradAndDrop",
    4: "ClosedText",
    5: "OpenText",
    6: "YesNo",
    7: "Emoji",
    8: "Numbers",
}